import { useState, useEffect } from 'react';
import { Download, X, Smartphone } from 'lucide-react';

export default function PWAInstallBanner() {
  const [installPrompt, setInstallPrompt] = useState(null);
  const [showBanner, setShowBanner] = useState(false);
  const [isInstalled, setIsInstalled] = useState(false);

  useEffect(() => {
    // Zaten kurulu mu kontrol et
    if (window.matchMedia('(display-mode: standalone)').matches) {
      setIsInstalled(true);
      return;
    }

    // Daha önce reddetti mi kontrol et
    const dismissed = localStorage.getItem('pwa_banner_dismissed');
    if (dismissed) {
      const dismissedDate = new Date(dismissed);
      const now = new Date();
      const diffDays = (now - dismissedDate) / (1000 * 60 * 60 * 24);
      // 7 günden eski ise tekrar göster
      if (diffDays < 7) return;
    }

    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setInstallPrompt(e);
      setShowBanner(true);
    };

    const handleAppInstalled = () => {
      setIsInstalled(true);
      setShowBanner(false);
      localStorage.removeItem('pwa_banner_dismissed');
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    window.addEventListener('appinstalled', handleAppInstalled);

    // iOS için manuel kontrol (Safari'de beforeinstallprompt desteklenmez)
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isIOS && isSafari && !window.matchMedia('(display-mode: standalone)').matches) {
      // iOS'ta 3 saniye sonra manuel banner göster
      const timer = setTimeout(() => {
        const iosDismissed = localStorage.getItem('pwa_ios_banner_dismissed');
        if (!iosDismissed) setShowBanner(true);
      }, 3000);
      return () => clearTimeout(timer);
    }

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
      window.removeEventListener('appinstalled', handleAppInstalled);
    };
  }, []);

  const handleInstall = async () => {
    if (!installPrompt) {
      // iOS manuel kurulum talimatı
      alert('iPhone\'da Safari paylaş butonuna basıp "Ana Ekrana Ekle" seçeneğini kullanın.');
      return;
    }

    installPrompt.prompt();
    const { outcome } = await installPrompt.userChoice;

    if (outcome === 'accepted') {
      setShowBanner(false);
    }
    setInstallPrompt(null);
  };

  const handleDismiss = () => {
    setShowBanner(false);
    localStorage.setItem('pwa_banner_dismissed', new Date().toISOString());
  };

  if (isInstalled || !showBanner) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[100] animate-in slide-in-from-top">
      <div className="bg-gradient-to-r from-emerald-600 to-emerald-500 text-white px-4 py-3 shadow-lg">
        <div className="max-w-xl mx-auto flex items-center justify-between gap-3">
          <div className="flex items-center gap-3 flex-1 min-w-0">
            <div className="w-10 h-10 rounded-xl bg-white/20 flex items-center justify-center flex-shrink-0">
              <Smartphone size={20} className="text-white" />
            </div>
            <div className="min-w-0">
              <p className="text-sm font-bold truncate">AGE Saha Paneli</p>
              <p className="text-[11px] text-emerald-100 truncate">
                Ana ekrana ekleyin, hızlıca erişin
              </p>
            </div>
          </div>

          <div className="flex items-center gap-2 flex-shrink-0">
            <button
              onClick={handleInstall}
              className="px-4 py-2 bg-white text-emerald-700 rounded-xl text-xs font-black uppercase tracking-wider hover:bg-emerald-50 active:scale-95 transition-all flex items-center gap-1.5"
            >
              <Download size={14} />
              Ekle
            </button>
            <button
              onClick={handleDismiss}
              className="p-2 text-emerald-200 hover:text-white hover:bg-white/10 rounded-xl transition-all"
            >
              <X size={18} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}